import { AccountAccess } from "../components/account-access.component";
import { Footer } from "../components/footer.component";
import Header from "../components/header.component";
import { PartnerLogo } from "../components/partner-logo.component";
import { certificate, graphArrow } from "../components/images/svg/icons";
import { StartupSectionImage } from "../components/images/png/icons";
import { WhyChooseInvozioSection } from "../components/why-choose-invozio-section.component";
import { BookKeepingSection } from "../components/book-keeping/book-keeping-section.component";
import { useTranslation } from "react-i18next";
import { PricingPlans } from "../components/book-keeping/pricing-plan.component";
import { getItem, getLocalizedPathFromLocalStorage } from "../helper/localstorage.helper";
import { useNavigate } from "react-router-dom";
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
import SEOMetadataComponent from '../components/seo-metadata.component';
const BookKeepingPage = () => {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
  const canonicalUrl = isEnglish
    ? `https://www.invozio.com/book-keeping?lang=${LOCALES.EN_US}`
    : `https://www.invozio.com/bokforing?lang=${LOCALES.SV_SE}`;


  const schemaMarkup = getSchemaMarkup("bokforing");
  const navigate = useNavigate();

  function navigateToRoute(EnglishPath: string, swedishPath: string) {
    navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': swedishPath, 'en-us': EnglishPath }));
  }

  return (
    <>
      <Header />
      <SEOMetadataComponent
        title={t('START_YOUR_BUSINESS_TITLE')}
        // description={t('FEATURES_MAIN_DESCRIPTION')}
        canonicalUrl={canonicalUrl}
        noindex={false}
        robots="index, follow"
        schemaMarkup={schemaMarkup}
      />
      <BookKeepingSection navigateToRoute={navigateToRoute} />
      <PartnerLogo />
      <WhyChooseInvozioSection
        image={StartupSectionImage}
        imageAlt={t("CHOOSE_INVOZIO_IMAGE_ALT")}
        title={t("DO_YOU_WANT_TO_START_YOUR_OWN_COMPANY")}
        description={t("DO_YOU_WANT_TO_START_YOUR_OWN_COMPANY_DESC")}
        features={[
          {
            icon: graphArrow,
            title: t("GREATER_STABILITY_AND_GROWTH_POTENTIAL"),
            description: t("GREATER_STABILITY_AND_GROWTH_POTENTIAL_DESC"),
          },
          {
            icon: certificate,
            title: t("COMPREHENSIVE_BUSINESS_SUPPORT"),
            description: t("COMPREHENSIVE_BUSINESS_SUPPORT_DESC"),
          },
        ]}
        navigateToRoute={navigateToRoute}
        buttonText={t("READ_MORE")}
      />
      <PricingPlans navigateToRoute={navigateToRoute} />
      <div className="bg-footer">
        <AccountAccess />
        <Footer />
      </div>
    </>
  );
};

export default BookKeepingPage;
